/**
 * 消息盒子点击处理函数
 */
import axiosUtil from "./AxiosUtils.js"
import { formatUnixTime } from "./DateFormat";
export default function msgBoxListUtils(vue, recData){
    let allData = JSON.parse(recData);
    let data = JSON.parse(allData.messageJson);
    if(!allData.isread){// 未读设为已读
        let options = {
            token: localStorage.getItem("token"),
            Service: "nethos.system.messagebox.read.all"
        };
        axiosUtil(options, function(){// 标记为已读
            vue.$store.dispatch("changeMsgBoxListCounts", false);// 消息盒子未读数-1
        });
    }

    switch (data.type){
        /**
         * 医生端问诊推送
         */
        case "A1": // 发布问诊推送
            if(data.consultType == "DOCPIC"){//图文咨询
                vue.$router.push({ name: "pictureToDeal", params: { consultId: data.consultId }} );
            }else if(data.consultType == "DOCVIDEO"){//视频咨询
                vue.$router.push({ name: "videoDoDeal", params: { consultId: data.consultId }} );
            }
            break;
        case "A3": // 患者补充了资料推送
            if(data.consultId == vue.$route.params.consultId){// 当前页面正好在需要跳转的页面，则重新刷新
                vue.$store.dispatch("getRefreshConsultId", data.consultId);
            }
            vue.$router.push({ name: "videoDoDeal", params: { consultId: data.consultId }} );
            break;
        case "A4": // 回复问诊
            if(data.consultType == "DOCPIC"){//图文咨询
                vue.$router.push({ name: "pictureToTreat", params: { consultId: data.consultId }});
            }else if(data.consultType == "VIDEO"){// 名医视频
                vue.$router.push({ name: "videoEntry", params: { consultId: data.consultId }} );
            }else if(data.consultType == "DOCVIDEO"){// 在线医生视频
                vue.$router.push({ name: "videoDoDeal", params: { consultId: data.consultId }} );
            }
            break;
        case "A5": // 完成问诊
            if(data.consultType == "DOCPIC"){//图文咨询
                vue.$store.dispatch("getCurrentPatientTab" ,"ywc");// 侧边列表更新
                vue.$router.push({ name: "pictureToTreat", params: { consultId: data.consultId }});
            }else if(data.consultType == "DOCVIDEO" || data.consultType == "VIDEO"){//视频问诊
                vue.$router.push({ name: "videoAdvisoryOpinion", params: { consultId: data.consultId }} );
            }
            break;
        case "A7": // 邀请视频
            if(data.consultType == "DOCVIDEO"||data.consultType == "VIDEO"){//在线医生视频问诊
                vue.$router.push({ name: "info-invitationVideoView", params: { consultId: data.consultId }} );
            }
            break;
        case "A8": // 取消问诊
            if(data.consultType == "DOCPIC"){// 图文咨询取消
                vue.$store.dispatch("getCurrentPatientTab" ,"yqx");
                vue.$router.push({ name: "pictureToTreat", params: { consultId: data.consultId }});
            }else if(data.consultType == "DOCVIDEO"||data.consultType == "VIDEO"){// 视频问诊
                vue.$router.push({ name: "videoViewFinished", params: { consultId: data.consultId }} );
            }
            break;
        case "A9": // 安排问诊
            if(data.consultType == "VIDEO"){// 名医视频
                vue.$router.push({ name: "videoEntry", params: { consultId: data.consultId }} );
            }
            break;
        case "A11":
            if(data.isInvitee){// 被邀请医生的推送
                vue.$router.push({ name: "info-invitationVideoView", params: { consultId: data.consultId }} );
            }else {
                vue.$router.push({ name: "videoEntry", params: { consultId: data.consultId }} );
            }
            break;
        /**
         * 远程会诊推送
         */
        case "B1": //会诊发布推送
             if(data.consultGroupNo.charAt(0)=="A"){// 医助医会诊
                 vue.$router.push({ name: "remoteEntry", params: { consultId: data.consultId }} );
             }else {//医医会诊
                 vue.$router.push({ name: "remoteEntryDoc", params: { consultId: data.consultId }} );
             }
            break;
        case "B2": // 取消会诊
            vue.$router.push({ name: "remoteReject", params: { consultId: data.consultId }} );
            break;
        case "B3": // 安排了会诊推送(发起医生接受)
            if(data.consultGroupNo.charAt(0)=="A") {// 医助医会诊
                if(data.initDocId){// 发起方收到
                    vue.$router.push({name: "remoteToDeal", params: {consultId: data.consultId}});
                }else {
                    vue.$router.push({ name: "remoteEntry", params: { consultId: data.consultId }} );
                }
            }else {
                vue.$router.push({name: "remoteToDeal", params: {consultId: data.consultId}});
            }
            break;
        case "B4": //  要求补充资料（发起医生接受）
            if(data.consultTime){// 安排时间我收到中
                if(data.consultId == vue.$route.params.consultId){// 当前页面正好在需要跳转的页面，则重新刷新
                    vue.$store.dispatch("getRefreshConsultId", data.consultId);
                }
                if(data.consultGroupNo.charAt(0)=="A"){// 接收方医生
                    vue.$router.push({ name: "remoteEntry", params: { consultId: data.consultId }} );
                }else {// 发起方医生
                    vue.$router.push({ name: "remoteEntryDoc", params: { consultId: data.consultId }} );
                }
            }else {// 我发起中
                vue.$router.push({ name: "remoteToDeal", params: { consultId: data.consultId }});
            }
            break;
        case "B5": //  补充了资料（接收医生接收）
            if(data.consultGroupNo.charAt(0)=="A"){// 医助医会诊
                vue.$router.push({ name: "remoteEntry", params: { consultId: data.consultId }} );
            }else {//医医会诊
                vue.$router.push({ name: "remoteEntryDoc", params: { consultId: data.consultId }} );
            }
            break;
        case "B6": //  邀请视频
            vue.$router.push({ name: "group-invitationVideoView", params: { consultId: data.consultId }} );
            break;
        case "B7": // 接收方医生填写问诊建议
        case "B8": // 结束会诊
            vue.$router.push({ name: "remoteEvaluate", params: { consultId: data.consultId }} );
            break;
        case "B9":// 开始时间推送
        case "B10":// 会话聊天推送
            if(data.isInvitee){// 被邀请医生的推送
                vue.$router.push({ name: "group-invitationVideoView", params: { consultId: data.consultId }} );
            }else {
                if(data.consultGroupNo.charAt(0)=="A"){// 医助医会诊
                    if(data.initDocId) {// 发起方收到
                        vue.$router.push({name: "remoteToDeal", params: {consultId: data.consultId}});
                    }else {
                        vue.$router.push({name: "remoteEntry", params: {consultId: data.consultId}});
                    }
                }else {//医医会诊
                    vue.$router.push({ name: "remoteEntryDoc", params: { consultId: data.consultId }} );
                }
            }
            break;
        /*医患关系会话推送*/
        case "f1":
            vue.$router.push({ name: "myPatientWebChat", params: {followId: data.followId}});
            break;
        /*会议中心推送*/
        case "MEETING_CREATE": //创建会议推送
            vue.$router.push({name: "MeetingManagement", params: {id: data.id}});
            vue.$router.push({name: "MeetingManagementDetail", params: {id: data.id}});
            break;
        case "MEETING_MODIFY": //修改会议推送
            vue.$router.push({name: "MeetingManagement", params: {id: data.id}});
            vue.$router.push({name: "MeetingManagementDetail", params: {id: data.id}});
            break;
        case "MEETING_CANCEL": //取消会议推送
            vue.$router.push({name: "MeetingManagement", params: {id: data.id}});
            vue.$router.push({name: "MeetingManagementDetail", params: {id: data.id}});
            break;
    }
}